{
  "WHITE_LABEL": "",
  "APP_SCHEME": "partageclub",
  "APPLE_APP_ID": "6755892083",
  "CONTACT_EMAIL": "info@we-partake.com",
  "SUPPORTED_LANGUAGES": ["en", "fr", "es"],
  "FEATURE_FLAGS_ENABLED": ["freeSubPrograms", "guestAccess", "invite", "lastName", "listMembers", "measureImpact", "popularItemsByTags", "possibleActivationCodeDuringSignup", "predictions", "promptSharerType", "publishListings", "rateAfterLoans", "referralPrize", "showRecommendedForYou", "similarListings", "sso", "superSharer", "useNewOnboarding", "viewSubscription", "conciergerie", "streak"]
}
